import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import DiwaliCrackers from './components/DiwaliCrackers'
import ChatBot from './components/ChatBot'
import Home from './pages/Home'
import Services from './pages/Services'
import Tracking from './pages/Tracking'
import Trackings from './pages/Trackings'
import About from './pages/About'
import Testimonials from './pages/Testimonials'
import QuotePage from './pages/QuotePage'
import PickupRequest from './pages/PickupRequest'
import ContactPage from './pages/ContactPage'
import CareersPage from './pages/CareersPage'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import PTLPage from './pages/PTLPage'
import LTLPage from './pages/LTLPage'
import FTLPage from './pages/FTLPage'
import ThreePLPage from './pages/3PLPage'
import InternationalShippingPage from './pages/InternationalShippingPage'
import LastMileDeliveryPage from './pages/LastMileMultimodalPage'
import AirFreightForwardingPage from './pages/AirFreightForwardingPage'
import SupplyChainpage from './pages/SupplyChainManagementPage'
import SurfaceExpressTransportationPage from './pages/SurfaceExpressTransportationPage'
import RailCargoExpressPage from './pages/RailCargoExpressPage'
import ContractLogisticsPage from './pages/ContractLogisticsPage'
import CLPage from './pages/CLPage'
import BusinessAccount from './pages/BusinessAccount'
import ClientRegistration from './pages/ClientRegistration'
import WarehousingPage from './pages/WarehousingPage'
import ColdChainPage from './pages/ColdChainPage'
import BlogPage from './pages/BlogPageSection'
import BlogDetail from './pages/BlogDetail'
import ExpressDeliveryPage from './pages/ExpressDeliveryPage'
import ExploreOurExpertise from './pages/ExploreOurExpertise'
import ScrollToTopButton from './components/ScrollToTopButton'
import ScrollToTop from './components/ScrollToTop'
import NeedMore from './pages/NeedMore'
import WhatsAppButton from './components/WhatsAppButton'
import ServiceabilityPage from './pages/ServiceabilityPage'
import FranchiseRegistration from './pages/FranchiseRegistration'
import OurServices from './pages/OurServices'
import NotFoundPage from './pages/NotFoundPage'

function App () {
  return (
    <Router>
      <ScrollToTop />
      <div className='min-h-screen flex flex-col'>
        <Header />
        <DiwaliCrackers />
        <main className='flex-grow'>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about-us' element={<About />} />
            <Route path='/blogs' element={<BlogPage />} />
            <Route path='/blogs/:id' element={<BlogDetail />} />
            <Route path='/services' element={<Services />} />
            <Route path='/services/ptl' element={<PTLPage />} />
            <Route path='/services/ltl' element={<LTLPage />} />
            <Route path='/services/ftl' element={<FTLPage />} />
            <Route path='/services/3pl' element={<ThreePLPage />} />
            <Route path='/services/cold-chain' element={<ColdChainPage />} />
            <Route
              path='/services/last-mile-delivery'
              element={<LastMileDeliveryPage />}
            />
            <Route
              path='/services/supply-chain-management'
              element={<SupplyChainpage />}
            />
            <Route
              path='/services/contract-logistics'
              element={<ContractLogisticsPage />}
            />
            <Route
              path='/services/surface-express'
              element={<SurfaceExpressTransportationPage />}
            />
            <Route
              path='/services/rail-cargo'
              element={<RailCargoExpressPage />}
            />
            <Route
              path='/services/air-freight-forwarding'
              element={<AirFreightForwardingPage />}
            />
            <Route
              path='/services/international'
              element={<InternationalShippingPage />}
            />
            <Route path='/services/cl' element={<CLPage />} />
            <Route path='/services/warehousing' element={<WarehousingPage />} />
            <Route
              path='/services/express-delivery'
              element={<ExpressDeliveryPage />}
            />
            <Route
              path='/industry-expertise'
              element={<ExploreOurExpertise />}
            />
            <Route
              path='/industry-expertise/:industry'
              element={<ExploreOurExpertise />}
            />
            <Route path='/track-shipment' element={<Tracking />} />
            <Route path='/track-shipment-v2/:lrno' element={<Trackings />} />
            <Route path='/support' element={<NeedMore />} />
            <Route path='/testimonials' element={<Testimonials />} />
            <Route path='/get-a-quote' element={<QuotePage />} />
            <Route path='/pickup-request' element={<PickupRequest />} />
            <Route path='/contact-us' element={<ContactPage />} />
            <Route path='/join-us' element={<BusinessAccount />} />
            <Route path='/join-us/career' element={<CareersPage />} />
            <Route
              path='/join-us/client-registration'
              element={<ClientRegistration />}
            />
            <Route
              path='/join-us/franchise'
              element={<FranchiseRegistration />}
            />
            <Route path='/privacy-policy' element={<PrivacyPage />} />
            <Route path='/terms-and-conditions' element={<TermsPage />} />
            <Route path='/our-services' element={<OurServices />} />
            <Route
              path='/check-serviceability'
              element={<ServiceabilityPage />}
            />
            <Route path='*' element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
        <ScrollToTopButton />
        <ChatBot />
        <WhatsAppButton />
      </div>
    </Router>
  )
}

export default App
